import { AMOUNT_TRANSLATIONS } from '../../components/Amount/Amount.constants';
import { AUTOCOMPLETE_TRANSLATIONS } from '../../components/Autocomplete/Autocomplete.constants';
import { BUTTON_TRANSLATIONS } from '../../components/Button/Button.constants';
import { CAROUSEL_TRANSLATIONS } from '../../components/Carousel/Carousel.constants';
import { CURRENCY_FIELD_TRANSLATIONS } from '../../components/CurrencyField/CurrencyField.constants';
import { DATE_PICKER_TRANSLATIONS } from '../../components/DatePicker/DatePicker.constants';
import { LOADER_TRANSLATIONS } from '../../components/Loader/Loader.constants';
import { MENU_TRANSLATIONS } from '../../components/Menu/Menu.constants';
import { NUMBER_FIELD_TRANSLATIONS } from '../../components/NumberField/NumberField.constants';
import { PASSWORD_FIELD_TRANSLATIONS } from '../../components/PasswordField/PasswordField.constants';
import { TABLE_TRANSLATIONS } from '../../components/Table/Table.constants';
import { TOOLTIP_TRANSLATIONS } from '../../components/Tooltip/Tooltip.constants';
import { Language } from '../../components/constants';
import { COOKIE_WIDGET_TRANSLATIONS } from '../../components/experimental/CookieWidget/CookieWidget.constants';
function combineTranslations() {
  const combinedTranslations = {};
  for (var _len = arguments.length, translations = new Array(_len), _key = 0; _key < _len; _key++) {
    translations[_key] = arguments[_key];
  }
  for (const currentTranslation of translations) {
    for (const language of Object.values(Language)) {
      if (!combinedTranslations[language]) {
        combinedTranslations[language] = {};
      }
      combinedTranslations[language] = {
        ...combinedTranslations[language],
        ...currentTranslation[language]
      };
    }
  }
  return combinedTranslations;
}
let translations = combineTranslations(LOADER_TRANSLATIONS, AMOUNT_TRANSLATIONS, MENU_TRANSLATIONS, NUMBER_FIELD_TRANSLATIONS, TABLE_TRANSLATIONS, CAROUSEL_TRANSLATIONS, AUTOCOMPLETE_TRANSLATIONS, DATE_PICKER_TRANSLATIONS, BUTTON_TRANSLATIONS, COOKIE_WIDGET_TRANSLATIONS, CURRENCY_FIELD_TRANSLATIONS, TOOLTIP_TRANSLATIONS, PASSWORD_FIELD_TRANSLATIONS);
export function configureTranslations(configuredTranslations) {
  translations = {
    ...translations,
    ...configuredTranslations
  };
}
export function getTranslations(language) {
  const translationsForLanguage = translations[language] || translations[Language.EN];
  return translationsForLanguage;
}